import { X } from "lucide-react";

export const BlocksPanel = ({ blocks, resources, newBlock, setNewBlock, onAdd, onRemove, onClose }) => (
  <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: "rgba(0,0,0,0.7)" }} data-testid="blocks-panel">
    <div className="w-full max-w-lg max-h-[85vh] overflow-y-auto p-6 border" style={{ background: "var(--ss-bg)", borderColor: "var(--ss-rust)" }}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-label text-sm tracking-widest" style={{ color: "var(--ss-cream)" }}>MANUAL BLOCKS</h3>
        <button data-testid="blocks-panel-close" onClick={onClose} aria-label="Close"><X size={18} /></button>
      </div>
      <div className="grid gap-2 sm:grid-cols-3 mb-3">
        <select data-testid="blocks-new-resource" value={newBlock.resource} onChange={(e) => setNewBlock({ ...newBlock, resource: e.target.value })}
                className="bg-transparent border px-2 py-2 text-sm" style={{ borderColor: "var(--ss-line, #444)" }}>
          {resources.map((r) => <option key={r.key} value={r.key}>{r.label}</option>)}
        </select>
        <input data-testid="blocks-new-date" type="date" value={newBlock.date} onChange={(e) => setNewBlock({ ...newBlock, date: e.target.value })}
               className="bg-transparent border px-2 py-2 text-sm" style={{ borderColor: "var(--ss-line, #444)" }} />
        <input data-testid="blocks-new-reason" placeholder="Reason (optional)" value={newBlock.reason} onChange={(e) => setNewBlock({ ...newBlock, reason: e.target.value })}
               className="bg-transparent border px-2 py-2 text-sm" style={{ borderColor: "var(--ss-line, #444)" }} />
      </div>
      <button data-testid="blocks-add-btn" onClick={onAdd} className="btn-primary w-full mb-5">Block date</button>
      {blocks.length === 0 && <p className="text-sm" style={{ color: "var(--ss-cream-dim)" }} data-testid="blocks-empty">No manual blocks.</p>}
      <ul className="space-y-2">
        {[...blocks].sort((a, b) => a.date.localeCompare(b.date)).map((bl) => (
          <li key={bl.id} data-testid={`blocks-item-${bl.id}`} className="flex items-center justify-between gap-3 border px-3 py-2 text-sm" style={{ borderColor: "var(--ss-line, #444)" }}>
            <span className="min-w-0 break-words">{bl.date} · {resources.find((r) => r.key === bl.resource)?.label || bl.resource}{bl.reason ? ` — ${bl.reason}` : ""}</span>
            <button data-testid={`blocks-remove-${bl.id}`} onClick={() => onRemove(bl.id)} className="btn-outline shrink-0">Unblock</button>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
